(() => {
  if (window.jaxLocationsInitialized) return;
  window.jaxLocationsInitialized = true;

  const storageKey = 'jax-location-id';
  const validLocationIds = new Set(['san-pedro-nl', 'jax-moto-lab-leon']);

  const getStoredLocation = () => {
    try {
      const id = window.sessionStorage.getItem(storageKey);
      return validLocationIds.has(id) ? id : '';
    } catch (error) {
      return '';
    }
  };

  const storeLocation = (id) => {
    if (!validLocationIds.has(id)) return;
    try {
      window.sessionStorage.setItem(storageKey, id);
    } catch (error) {
      // The form still works when browser storage is unavailable.
    }
  };

  const params = new URLSearchParams(window.location.search);
  const queryLocation = params.get('location_id');

  document.querySelectorAll('[data-jax-location-select]').forEach((select) => {
    const preferredLocation = validLocationIds.has(select.value)
      ? select.value
      : (validLocationIds.has(queryLocation) ? queryLocation : getStoredLocation());

    if (preferredLocation) select.value = preferredLocation;
    const form = select.form;
    const exposeLocation = () => {
      if (validLocationIds.has(select.value) && form) {
        form.dataset.locationId = select.value;
      }
    };

    exposeLocation();
    select.addEventListener('change', exposeLocation);
    if (form) {
      form.addEventListener('submit', () => {
        if (validLocationIds.has(select.value)) {
          form.dataset.locationId = select.value;
          storeLocation(select.value);
        }
      });
    }
  });

  document.querySelectorAll('[data-jax-lead-success]').forEach((success) => {
    const locationId = validLocationIds.has(success.dataset.locationId)
      ? success.dataset.locationId
      : getStoredLocation();
    if (locationId) {
      success.dataset.locationId = locationId;
    }
  });

})();
